<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <!-- 工事日報タイトル -->
          <v-card-title>
            工事日報
          </v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12" md="4">
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-text-field class="mt-3" label="作業日" v-model="constructionDate" prepend-inner-icon="mdi-calendar-month" dense outlined readonly/>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-text-field class="mt-3" label="工番" v-model="constructionNumber" prepend-inner-icon="mdi-newspaper-variant-outline" dense outlined readonly/>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-text-field class="mt-3" label="現場名" v-model="constructionName" prepend-inner-icon="mdi-crane" dense outlined readonly/>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="4" class="ml-5">
                <v-data-table :headers="reportTotalHeaders" :items="reportTotalDataTable" show-expand item-key="name" :expanded.sync="expanded" hide-default-header hide-default-footer>
                  <template slot="top">
                    <v-toolbar color="accent" dark flat dense>
                        <v-toolbar-title>日報総計</v-toolbar-title>
                    </v-toolbar>
                  </template>
                  <template v-slot:[`item.data-table-expand`]="{ item, isExpanded, expand }">
                    <v-btn icon text @click="expand(true)" v-if="item.canExpand && !isExpanded"><v-icon>mdi-chevron-down</v-icon></v-btn>
                    <v-btn icon text @click="expand(false)" v-if="item.canExpand && isExpanded"><v-icon>mdi-chevron-up</v-icon></v-btn>
                  </template>
                  <template v-slot:expanded-item="{ headers }">
                    <td :colspan="headers.length">
                      <v-data-table dense :headers="headers" :items="reportAggregateDataTable" :items-per-page="itemPerPage" hide-default-header hide-default-footer>
                        <template v-slot:no-data>データがありません</template>
                      </v-data-table>
                    </td>
                  </template>
                  <template v-slot:no-data>データがありません</template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>

          <!-- タブヘッダー -->
          <v-tabs v-model="selectTab" background-color="accent" dark show-arrows next-icon="mdi-arrow-right-bold-box-outline" prev-icon="mdi-arrow-left-bold-box-outline">
            <v-tab v-for="index in tabLength" :key="index" :href="'#tab-'+index">{{ "工種：" + tabDataList['tab-'+index].tabName }}</v-tab>
            <v-tabs-slider color="red"/>
          </v-tabs>
          <!-- タブボディ -->
          <v-tabs-items v-model="selectTab">
            <v-tab-item v-for="index in tabLength" :key="index" :value="'tab-'+index">
              <v-container fluid>
                <!-- 作業報告 -->
                <v-row>
                  <v-col cols="12">
                    <v-data-table :headers="workHeaders" :items="tabDataList['tab-' + index].workDataTable" :items-per-page="itemPerPage" hide-default-footer>
                      <template slot="top">
                        <v-toolbar color="accent" dark flat dense>
                            <v-toolbar-title>作業報告</v-toolbar-title>
                        </v-toolbar>
                      </template>
                      <template v-slot:[`item.work`]="{ item }">
                        <v-btn class="my-2" depressed small color="info" @click.stop="showWorkerContentReferenceDialog(item)">作業内容参照</v-btn>
                      </template>
                      <template v-slot:no-data>データがありません</template>
                    </v-data-table>
                    <v-divider></v-divider>
                    <v-data-table :headers="achievementWorkHeaders" :items="tabDataList['tab-' + index].employmentCostDataTable" :items-per-page="itemPerPage" hide-default-footer>
                      <template slot="top">
                        <v-toolbar color="grey" dark flat dense>
                            <v-toolbar-title>{{ workIndexName }}</v-toolbar-title>
                        </v-toolbar>
                      </template>
                      <template v-slot:no-data>データがありません</template>
                    </v-data-table>
                  </v-col>
                </v-row>
                <!-- 経費区分 -->
                <v-row>
                  <v-col cols="12">
                    <v-toolbar color="accent" dark flat dense>
                      <v-toolbar-title>経費区分</v-toolbar-title>
                    </v-toolbar>
                    <div v-for="(data, name) in tabDataList['tab-' + index].expenseTableData" :key="name">
                      <v-row class="mt-2">
                        <v-col cols="12">
                          <v-data-table :headers="expenseHeaders" :items="data" :items-per-page="itemPerPage" hide-default-footer>
                            <template slot="top">
                              <v-toolbar color="grey" dark flat dense>
                                  <v-toolbar-title>{{ name }}</v-toolbar-title>
                              </v-toolbar>
                            </template>
                            <template v-slot:no-data>データがありません</template>
                          </v-data-table>
                          <v-divider></v-divider>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-data-table :headers="totalHeaders" :items="tabDataList['tab-' + index].totalDataTable" :items-per-page="itemPerPage" hide-default-header hide-default-footer>
                      <template slot="top">
                        <v-toolbar color="accent" dark flat dense>
                            <v-toolbar-title>総計</v-toolbar-title>
                        </v-toolbar>
                      </template>
                      <template v-slot:no-data>データがありません</template>
                    </v-data-table>
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
          </v-tabs-items>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="grey lighten-1" :to="{ name: 'ConstructionDailyReport', params: { number: this.constructionNumber } }">戻る</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="workerContentReferenceDialogDrawer" persistent max-width="700">
        <v-card>
          <v-card-title class="headline">作業内容参照</v-card-title>
          <v-card-text v-if="tabLength > 0">
            <v-toolbar color="accent" dark flat dense><v-toolbar-title>{{ constructionName }}</v-toolbar-title></v-toolbar>
            <v-row>
              <v-col cols="2"><header>作業者</header></v-col>
              <v-col cols="10"><header>{{ this.workItem.worker }}</header></v-col>
            </v-row>
            <v-divider/>
            <v-row>
              <v-col cols="2"><header>作業内容</header></v-col>
              <v-col cols="10"><header style="white-space:pre-wrap; word-wrap:break-word;">{{ this.workItem.work }}</header></v-col>
            </v-row>
            <v-divider/>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="grey lighten-1" @click.stop="workerContentReferenceDialogDrawer = false">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { useAppInsights } from '@/plugins/application-insights';
import statusList from "@/helpers/const";
import ConstructionDailyReportApi from "@/api/construction-daily-report-api";
import CalcCommon from "@/helpers/calcCommon";

export default {
  name: "ConstructionDailyReportInfo",
  props: ["user"],
  data: () => ({
    // ------------------------
    // 共通
    // ------------------------
    loading: false,
    // 作業日
    constructionDate: "",
    // 工番ID
    constructionID: "",
    // 工番名
    constructionNumber: "",
    // 現場名
    constructionName: "",
    // データ表示数
    itemPerPage: 300,

    // ------------------------
    // タブ
    // ------------------------
    tabLength: 0,
    selectTab: null,

    tabData: {
      tabName: null,
      constructionType: null,
      workDataTable: [],
      employmentCostDataTable: [],
      expenseTableData: [],
      totalDataTable: []
    },
    // 本データ用
    tabDataList: {},
    confirmDisabled: false,

    // ------------------------
    // 日報総計
    // ------------------------
    workIndexName: "作業実績",
    totalIndexName: "総計",
    todayIndexName: "当計",
    budgetTotalIndexName: "予算累計",
    achievementTotalIndexName: "実績累計",
    reportTotalHeaders: [
      { text: "名称", value: "name" },
      { text: "計", value: "total", align: "end" },
      { text: '', value: 'data-table-expand' }
    ],
    reportTotalDataTable: [],
    reportAggregateDataTable: [],
    expanded: [],

    // ------------------------
    // 作業報告
    // ------------------------
    workHeaders: [
      { text: "作業者", value: "worker" },
      { text: "作業時間", value: "workerTime" },
      { text: "作業時間(休憩)", value: "breakWorkerTime" },
      { text: "実績作業時間", value: "achievementWorkerTime" },
      { text: "残業時間", value: "overTime" },
      { text: "残業時間(休憩)", value: "breakOverTime" },
      { text: "実績残業時間", value: "achievementOverTime" },
      { text: "作業内容", value: "work" }
    ],
    achievementWorkHeaders: [
      { text: "作業名", value: "workName" },
      { text: "実績作業時間", value: "totalTime" },
      { text: "単価(時)", value: "unitPrice", align: 'end' },
      { text: "金額(税抜)", value: "workPrice", align: 'end' }
    ],
    // ------------------------
    // 経費区分
    // ------------------------
    expenseHeaders: [
      { text: "費目名", value: "expense" },
      { text: "規格等", value: "standard" },
      { text: "実績 / 予算", value: "displayAchievement" },
      { text: "単位", value: "displayUnit" },
      { text: "単価", value: "unitPrice", align: 'end' },
      { text: "金額(税抜)", value: "price", align: 'end' },
      { text: "取引先", value: "supplierName" }
    ],
    // ------------------------
    // 総計
    // ------------------------
    totalHeaders: [
      { text: "費目名", value: "expense", align: "end" },
      { text: "金額(税抜)", value: "price", align: "end" }
    ],

    // ------------------------
    // 作業内容参照ダイアログ
    // ------------------------
    workItem: {},
    workerContentReferenceDialogDrawer: false,

    // 権限
    displayPermission: false
  }),
  created () {
    this.initialize();
  },
  methods: {
    isLoading() {
      this.loading = !this.loading;
      this.$emit("loading", this.loading);
    },
    initialize () {
      this.isLoading();
      if (this.user.role_id == 0) {
        this.displayPermission = this.user.permission_config.CTSG00013.display;
      }
      this.constructionDate = this.parseDate(this.$route.params.date);
      this.constructionID = this.$route.params.id;
      this.constructionNumber = this.$route.params.number;
      this.constructionName = this.$route.params.name;
      this.constructionDailyReportApi = new ConstructionDailyReportApi();
      const promise = this.constructionDailyReportApi.info(this.constructionDate, this.constructionID);
      promise.then((response) => {
        var report_info = response.data.body.construction_daily_report_info
        if (this.displayPermission) {
          report_info = response.data.body.construction_daily_report_all_info
        }
        for(var info of report_info) {
            this.tabLength++;
            this.selectTab = 'tab-'+this.tabLength;
            this.tabDataList[this.selectTab] = info.report;

            for (var employmentData of this.tabDataList[this.selectTab].employmentCostDataTable) {
              employmentData.unitPrice = CalcCommon.addFigure(employmentData.unitPrice);
              employmentData.workPrice = CalcCommon.addFigure(employmentData.workPrice);
            }
            for (var expanseIndex in this.tabDataList[this.selectTab].expenseTableData) {
              for (var expanseData of this.tabDataList[this.selectTab].expenseTableData[expanseIndex]) {
                expanseData.unitPrice = CalcCommon.addFigure(expanseData.unitPrice);
                expanseData.price = CalcCommon.addFigure(expanseData.price);
              }
            }
            for (var totalIndex in this.tabDataList[this.selectTab].totalDataTable) {
              this.tabDataList[this.selectTab].totalDataTable[totalIndex].price = CalcCommon.addFigure(this.tabDataList[this.selectTab].totalDataTable[totalIndex].price);
            }
        }
        this.selectTab = 'tab-1';
        this.reportTotalDataTable = [
          { name: this.todayIndexName, total: 0, canExpand: true },
          { name: this.budgetTotalIndexName, total: CalcCommon.addFigure(response.data.body.construction_info.budget_price), canExpand: false },
          { name: this.achievementTotalIndexName, total: CalcCommon.addFigure(response.data.body.construction_info.achievement_price), canExpand: false },
        ];
        this.updateReportTotal();
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else if (error.response.data.status == statusList.status.entityError) {
            this.$emit("error",error.response.data.message);
            this.$router.push({ name: "Dashboard" })
          } else {
            this.$emit("error",error.response.data.message);
          }
        } else {
          this.$emit("error","サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    },
    //日付フォーマット
    parseDate (date) {
      if (!date) return null;
      const [year,month, day] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    updateReportTotal() {
      var totalPrice = 0;
      var targetData = null;
      this.reportAggregateDataTable = [];
      for (var tabIndex in this.tabDataList) {
        for (var totalData of this.tabDataList[tabIndex].totalDataTable) {
          if (totalData.expense === this.totalIndexName) {
            continue;
          }
          totalPrice += CalcCommon.disFigure(totalData.price);
          targetData = this.reportAggregateDataTable.find((data) => {
              return (data.name === totalData.expense);
          });
          if (targetData) {
            targetData.total += CalcCommon.disFigure(totalData.price);
          } else {
            this.reportAggregateDataTable.push({
              name: totalData.expense,
              total: CalcCommon.disFigure(totalData.price)
            });
          }
        }
      }
      for (var aggregateData of this.reportAggregateDataTable) {
        aggregateData.total = CalcCommon.addFigure(aggregateData.total);
      }
      targetData = this.reportTotalDataTable.find((data) => {
          return (data.name === this.todayIndexName);
      });
      targetData.total = CalcCommon.addFigure(totalPrice);
    },

    // ---------------------------------------------
    // イベント処理「作業内容参照」ボタン押下
    // ---------------------------------------------
    showWorkerContentReferenceDialog(item) {
      this.workItem = item;
      this.workerContentReferenceDialogDrawer = true;
    },
  }
}
</script>
